import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import SignaturePad from "react-signature-canvas";
import { faCancel, faUpload, faXmark } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Btn } from "../../../AbstractElements";
const CoverageEmployeeSign = ({ values, setValues, openCanvas, closeCanvas, keyName }) => {
  let sigPad = {};
  const trimSign = () => {
    setValues(
      { ...values, [keyName]: sigPad.getTrimmedCanvas().toDataURL("image/png") }
    );
    // props.onBlurHandler(props?.signature, { target: { value: sigPad.getTrimmedCanvas().toDataURL("image/png") } })
  };
  const clearCanvas = () => {
    sigPad.clear();
  };

  return (
    <>
      {openCanvas ? (
        <div>
          <Dialog open={openCanvas} onClose={closeCanvas}>
            <DialogTitle>Draw Your Signature</DialogTitle>
            <DialogContent>
              <SignaturePad
                canvasProps={{ className: "sigPad", width: 450, height: 220 }}
                ref={(ref) => {
                  sigPad = ref;
                }}
              />
            </DialogContent>
            <DialogActions>
              <Btn
                attrBtn={{
                  color: "primary",
                  onClick: () => {
                    trimSign();
                    setTimeout(() => {
                      closeCanvas();
                    }, 10);
                  }
                }}>
                <FontAwesomeIcon icon={faUpload} /> &nbsp; Upload
              </Btn>
              <Btn
                attrBtn={{
                  color: "primary",
                  onClick: () => {
                    clearCanvas();
                  }
                }}>
                Clear
              </Btn>
              <Btn
                attrBtn={{
                  color: "primary",
                  onClick: () => {
                    closeCanvas();
                  }
                }}>
                <FontAwesomeIcon icon={faXmark} /> &nbsp; Cancel
              </Btn>
            </DialogActions>
          </Dialog>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
export default CoverageEmployeeSign;
